export const files = [
    { name: "data1.csv", content: "Column1,Column2,Column3\n1,2,3\n4,5,6" },
    { name: "data2.csv", content: "Header1,Header2,Header3\nA,B,C\nD,E,F" },
    {
        name: "data3.csv",
        content: "Name,Age,Location\nJohn,30,USA\nJane,25,Canada"
    },
    {
        name: "data4.csv",
        content: "Product,Price,Quantity\nApple,1.2,10\nBanana,0.8,20"
    },
    { name: "report1.csv", content: "Report,Value\nProfit,1000\nLoss,200" },
    {
        name: "report2.csv",
        content: "Date,Event\n2023-12-01,Meeting\n2023-12-02,Workshop"
    },
    {
        name: "report3.csv",
        content: "City,Population\nNew York,8000000\nLos Angeles,4000000"
    },
    { name: "report4.csv", content: "Category,Count\nBooks,500\nMovies,300" },
    { name: "analysis1.csv", content: "Metric,Score\nSpeed,90\nAccuracy,85" },
    {
        name: "analysis2.csv",
        content: "Type,Duration\nRun,30 mins\nWalk,60 mins"
    },
    { name: "analysis3.csv", content: "Test,Result\nMath,Pass\nEnglish,Fail" },
    {
        name: "analysis4.csv",
        content: "Item,Status\nLaptop,Checked\nPhone,Unchecked"
    }
];
